import { z } from "zod";

/**
 * Generation config — stored under `{ generation: { ... } }`.
 * _v: 1
 */
export const GenerationPromptConfigSchema = z.object({
  _v: z.literal(1).default(1),
  multimodal: z.boolean().default(false),
  expectedInput: z.string().optional(),
  jsonInputSchema: z.record(z.string(), z.unknown()).optional(),
  expectedOutput: z.string().optional(),
  jsonOutputSchema: z.record(z.string(), z.unknown()).optional(),
  documentTemplateId: z.string().optional()
});

export type GenerationPromptConfig = z.infer<typeof GenerationPromptConfigSchema>;
